
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Navbar from "../../../Components/Navbar";

import Siderbar from "../../../Components/Sidebar";
import ApiLoader from "../../../Components/Loader/ApiLoader";
import Toast from '../../../Components/Toast/Toast'
import DeletePopUP from "../../../Components/CommonPopUp/DeletePopUp";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../Helper/Context/context";
import { AgencyDetailsTableDataAPI } from "../../../Helper/Redux/MasterSlice/AgencyDetailsSlice";
import { Pegination } from "../../../Components/Pagination/Pagination";
import { Loading } from "../../../Helper/LogoLoader/LogoLoader";
import { NameOfAgencyDDL } from "../../../Components/CommonDDL/NameOfAgencyDDL";
import AddTalukaPopUp from "./PopUp/AddTalukaPopUp";
import { BlockMasterDeleteAPI, BlockMasterTableDataAPI } from "../../../Helper/Redux/MasterSlice/BlockMasterSlice";
import { StateNameDDL } from "../../../Components/CommonDDL/StateNameDDL";
import { DistrictDDL } from "../../../Components/CommonDDL/DistrictDDL";
import { TalukaNameDDL } from "../../../Components/CommonDDL/TalukaNameDDL";

export default function TalukaMaster() {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)

    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState({
        data: ''
    })
    const [IsPost, setIsPost] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    // Pagination
    const [IsClear, setIsClear] = useState(false)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [isopen, setIsOpen] = React.useState(false);

    const [StateID, setStateID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [DistrictID, setDistrictID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [TalukaID, setTalukaID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ShowAddModal, setShowAddModal] = useState({
        showHide: false,
        flag: '',
        data: ''
    })

    const handleShowAddModal = (show, flag, data) => {
        setShowAddModal({
            showHide: show,
            flag: flag,
            data: data
        })
    }

    const handleShowDelete = (data) => {
        setShowDeletePopup(!ShowDeletePopup)
        setShowDeletePopupData(data)
    }

    useEffect(() => {
        const data = {
            M_StateNameID: StateID.ID,
            M_DistrictNameID: DistrictID.ID,
            M_TalukaNameID: TalukaID.ID,
            FromTop: From,
            ToTop: To,
            token: token,
            M_TableUserMasterID: UserID
        }
        dispatch(BlockMasterTableDataAPI({ data }))
    }, [From, IsSearch, IsClear, IsPost, StateID.ID, DistrictID.ID, TalukaID.ID])

    const { isLoading, tableData } = useSelector(state => state.BlockMasterTableData)

    const handleIsPost = () => {
        handleShowAddModal(false, '')
        setShowDeletePopup(false)
        setIsPost(!IsPost)
    }

    const handleDeleteData = () => {
        const data = {
            M_TalukaNameID: ShowDeletePopupData?.m_TalukaNameID,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsPost
        }
        dispatch(BlockMasterDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.BlockMasterDeleteData)

    const handleClear = () => {
        setStateID({
            ...StateID,
            ID: 0,
            Label: "Select...",
        })
        setDistrictID({
            ...DistrictID,
            ID: 0,
            Label: "Select...",
        })
        setTalukaID({
            ...TalukaID,
            ID: 0,
            Label: "Select...",
        })
        setIsClear(!IsClear)
        setIsClear(!IsClear)
    }

    const handleSearch = () => {
        setIsSearch(!IsSearch)
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }
    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [StateID.ID, DistrictID.ID, TalukaID.ID])


    const toggle = () => {
        setIsOpen(!isopen);

    };

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div className="mt-2">
                <div className="container-scroller">
                    <Navbar
                        setYearValue={setYearValue}
                        setYearLabel={setYearLabel}
                        setMonthValue={setMonthValue}
                        setMonthLabel={setMonthLabel}
                        toggle={toggle}
                        isopen={isopen} />
                    <div className="container-fluid page-body-wrapper">

                        <Siderbar isopen={isopen} toggle={toggle} active="Taluka" />

                        <div className="main-panel" style={{ width: isopen ? "calc(100%  - 120px )" : "", marginLeft: isopen ? "130px" : "" }}>

                            <main className="main-content position-relative border-radius-lg " >

                                <div className="content-wrapper " >
                                    <div className="row">
                                        <div className="col-8 col-lg-8">
                                            <div className="row page-heading col-12 col-lg-12 col-md-12 mb-xl-0 px-1 px-lg-4 float-left">
                                                <h4 className="font-weight-semi-bold text-dark ">Block Master</h4>
                                            </div>
                                        </div>
                                        <div className="col-4 col-lg-4 mt-lg-1 " style={{ textAlign: 'end' }}>
                                            <a type="button" onClick={() => handleShowAddModal(true, 'Insert')} className="btn btn-dark border-2  "><i
                                                className="fa-solid fa-plus me-1"></i> Add</a>
                                        </div>
                                    </div>
                                    <div className="col-12 ">

                                        <div className="card mb-4 overflow-hidden">

                                            <div className="card-body px-4 py-2 linear-g">
                                                <div className="row mb-4 px-2">

                                                    <div className="col-xl-3 col-lg-3">
                                                        <StateNameDDL
                                                            StateID={StateID}
                                                            setStateID={setStateID}
                                                            apiFlag='Master'
                                                            Flag='Insert'
                                                            data=''
                                                            IsPost={IsPost}
                                                        />
                                                    </div>

                                                    <div className="col-xl-3 col-lg-3">
                                                        <DistrictDDL
                                                            DistrictID={DistrictID}
                                                            setDistrictID={setDistrictID}
                                                            StateID={StateID}
                                                            apiFlag='Master'
                                                        />
                                                    </div>


                                                    <div className="col-xl-3 col-lg-3">
                                                        <TalukaNameDDL
                                                            TalukaID={TalukaID}
                                                            setTalukaID={setTalukaID}
                                                            apiFlag='Master'
                                                            Flag='Insert'
                                                            data=''
                                                            IsPost={IsPost}
                                                            StateID={StateID}
                                                            DistrictID={DistrictID}
                                                        />

                                                    </div>



                                                    <div className="col-12 col-md-6 col-lg-3 pt-2 mt-3 mt-lg-2 pt-lg-4 pb-3 pb-lg-0 ">
                                                        {/* <button type="button" className="btn btn-outline-dark border-2 mx-2 "
                                                        // onClick={handleSearch}
                                                        >
                                                            Search</button> */}


                                                        <button type="button" className="btn btn-danger border-2"
                                                            onClick={handleClear}
                                                        >Clear</button>

                                                    </div>


                                                </div>

                                                {/* <TableData /> */}

                                                <div className="table-responsive p-0" >
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr className="bg-gradient-dark text-white">
                                                                <th className=" w-8 " style={{ width: "8%" }}>Sr. No.</th>
                                                                <th className=" ps-2">State</th>
                                                                <th className=" ps-2">District</th>
                                                                <th className=" ps-2">Block Name</th>
                                                                <th className=" ps-2  w-10 v_sr_width">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                tableData && tableData.table && tableData.table.length > 0 ?
                                                                    tableData.table.map((i, index) => {
                                                                        return (
                                                                            <tr>
                                                                                <td align="center">{i?.rowNum}</td>
                                                                                <td>{i.stateName ? i.stateName : '-'}</td>
                                                                                <td>{i.districtName ? i.districtName : '-'}</td>
                                                                                <td>{i.talukaName ? i.talukaName : '-'}</td>
                                                                                <td align="center">
                                                                                    <i className="fa fa-edit mx-2 v_icon_style" title="Edit"
                                                                                        onClick={() => {
                                                                                            handleShowAddModal(true, 'Update', i)
                                                                                        }}
                                                                                    ></i>
                                                                                    <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                                                        onClick={() => handleShowDelete(i)}
                                                                                        title="Do you want to delete this record?"></i>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    <>No data found</>
                                                            }


                                                        </tbody>
                                                    </table>
                                                </div>
                                                {tableData && tableData.table && tableData.table.length > 0 &&
                                                    <Pegination
                                                        PerPageCount={PerPageCount}
                                                        TotalCount={tableData.table[0].totalCount}
                                                        setFrom={setFrom}
                                                        setTo={setTo}
                                                        CurrentPage={CurrentPage}
                                                        setCurrentPage={setCurrentPage}
                                                        IsClear={IsClear}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            </div>


            {
                ShowAddModal.showHide &&
                <AddTalukaPopUp
                    handleShowAddModal={handleShowAddModal}
                    handleIsPost={handleIsPost}
                    ShowAddModal={ShowAddModal}
                />
            }
            {
                ShowDeletePopup ?
                    <DeletePopUP
                        handleShowDelete={handleShowDelete}
                        ShowDeletePopupData={ShowDeletePopupData}
                        handleDeleteData={handleDeleteData}
                    /> : <></>
            }

        </>
    )
}